"use client"

import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"

import { DisplayPaymentOptionsRequest, RetailDisplayPaymentOptionsResponse } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

export const useDisplayPaymentOptions = (amount?: number) => {
  const request = useMemo<DisplayPaymentOptionsRequest | null>(() => {
    if (!amount || amount <= 0) return null

    return {
      amount: {
        amountE5: Math.round(amount * 1000),
        currencyCode: "MXN",
      },
    }
  }, [amount])

  const { data, isLoading, error, refetch } = useQuery<RetailDisplayPaymentOptionsResponse>({
    queryKey: ["displayPaymentOptions", amount],
    queryFn: () => neloApiClient.getDisplayPaymentOptions(request!),
    enabled: !!request,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })

  return {
    paymentOptions: data?.retailDisplayPaymentOptions ?? [],
    isLoading,
    error,
    refetch,
  }
}

export default useDisplayPaymentOptions
